import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-lg font-bold text-white">韩国漫画网</span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed">
                致力于提供优质的韩漫在线阅读体验，每日更新热门韩漫，让您随时随地免费畅享精彩漫画世界。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">全部漫画</Link></li>
                <li><Link to="/category/recommended" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">热门推荐</Link></li>
                <li><Link to="/about" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/romance" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">恋爱漫画</Link></li>
                <li><Link to="/category/fantasy" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">奇幻漫画</Link></li>
                <li><Link to="/category/action" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">动作漫画</Link></li>
                <li><Link to="/category/mystery" className="text-sm text-secondary-300 hover:text-white transition-colors whitespace-nowrap">悬疑漫画</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-mail-line text-base"></i>
                  <span>contact@rhmeiji.cn</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-customer-service-2-line text-base"></i>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>韩国首尔特别市江南区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} 韩国漫画网. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}